var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-channel"},[_c('span',{staticClass:"ci-channel__icon",class:[
			_vm.icon
		]}),_c('ci-text',{staticClass:"ci-channel__title",attrs:{"type":"lead","bold":true,"theme":"primary"}},[_vm._v("\n\t\t"+_vm._s(_vm.title)+"\n\t")]),_c('ci-text',{staticClass:"ci-channel__text",attrs:{"type":"small"}},[_vm._v("\n\t\t"+_vm._s(_vm.content)+"\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }